import Ajax from "services/ajax";

export default class OneTimeStore {
  static fundPocket(payload, onSuccess, onError) {
    return Ajax.post("/pocket/funds", payload)
      .then(onSuccess)
      .catch(onError);
  }
}
